import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL';
import { STPMachEquipmentTypeDDL } from '../../../../../Components/CommonDDL/STPMachEquipmentTypeDDL';
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { STPMachineryDetailsPostDataAPI } from '../../../../../Redux/STPDashboardSlice/STPSidebarMaster/STPMachineryDetailsSlice';


export default function STPMachineryDetailsMasterPopup(props) {

    const { handleOnCloseClick, open, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost, apiFlag, rowData, HWard, WLable } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [MachEquipmentType, setMachEquipmentType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EquipmentDetails, setEquipmentDetails] = useState(Flag === 'Update' ? rowData.machineryDetails : '')



    const handlePost = () => {
        const data = {
            M_STP_MachineryDetailsID: Flag === 'Update' ? rowData.m_stP_MachineryDetailsID : '0',
            M_WardID: WardName.ID,
            M_STP_MachEquipmentTypeID: MachEquipmentType.ID,
            MachineryDetails: EquipmentDetails,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick
        }
        dispatch(STPMachineryDetailsPostDataAPI({ data }))

    }

    return (

        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="location_mob_pop modal-dialog modal-dialog-scrollable modal-xl" style={{ alignItems: "center", justifyContent: 'center' }}>
                <div className="modal-content road_ward_modal">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Machinery Details Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">
                                <div className="col-lg-6 col-md-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        HWard={HWard}
                                        WLable={WLable}
                                        rowData={rowData}
                                        Flag={Flag}
                                        IsDisabled={true}
                                    />

                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <STPMachEquipmentTypeDDL
                                        MachEquipmentType={MachEquipmentType}
                                        setMachEquipmentType={setMachEquipmentType}
                                        WardName={WardName}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />

                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Equipment Details </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="EquipmentDetails"
                                            value={EquipmentDetails}
                                            onChange={(e) => setEquipmentDetails(e.target.value)}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4 pt-3">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            MachEquipmentType.ID == 0 || EquipmentDetails == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button typtton type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}